import { createFileRoute } from "@tanstack/react-router";
import { PacotesHTTPPage } from "@/paginas/pg_dev/dev-pacotes-http-recebidos";

export const Route = createFileRoute("/_authenticated/dev-pacotes-http-recebidos")({
  head: () => ({
    meta: [
      { title: "Pacotes HTTP recebidos — Milky Moo Palmares" },
      {
        name: "description",
        content:
          "Listagem dos pacotes HTTP recebidos pelo sistema, com impressão e exportação PDF.",
      },
      { property: "og:title", content: "Pacotes HTTP recebidos — Milky Moo Palmares" },
      {
        property: "og:description",
        content:
          "Listagem dos pacotes HTTP recebidos pelo sistema, com impressão e exportação PDF.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PacotesHTTPPage,
});
